import { take, select, call } from 'redux-saga/effects';

export const awaitNeedValue = function* (selector, criterion) {
  while (true) {
    const value = yield select(selector);
    if (yield call(criterion, value)) {
      return value;
    }
    yield take('*');
  }
};
